import { useEffect, useState } from "react";
import About from "../components/About";
import Staff from "../components/Staff";
import Partners from "../components/Partners";
import ContactDetails from "../components/ContactDetails";
import { getAgentUserProfile } from "../../../../endpoints/hiringCompany/requirements";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../../../../assets/svg/LoadingAnimation";

const tabs = ["About", "Staff", "Partners", "Contact Details"];

const RenderBody = ({ activeTab }: { activeTab: number }) => {
  if (activeTab === 0) return <About />;
  if (activeTab === 1) return <Staff />;
  if (activeTab === 2) return <Partners />;
  if (activeTab === 3) return <ContactDetails />;
  return null;
};

const ViewProfile = () => {
  const params = useParams();
  const [agentUserDetails, setAgentUserDetails] = useState(null);
  const [isUserDetailsLoading, setIsUserDetailsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (value: number) => setActiveTab(value);

  const fetchUserDetails = async (recruiterId: string) => {
    try {
      setIsUserDetailsLoading(true);
      const { success, data } = await getAgentUserProfile(recruiterId);
      if (success) {
        setAgentUserDetails(data);
      }
    } catch (error) {
    } finally {
      setIsUserDetailsLoading(false);
    }
  };

  useEffect(() => {
    if (params?.agentId) {
      fetchUserDetails(params?.agentId);
    }
  }, []);

  if (isUserDetailsLoading)
    return (
      <div className="flex flex-1 justify-center itesm-center">
        <LoadingAnimation color="black" />
      </div>
    );

  return (
    <div className="px-8 pt-8 flex-1">
      <div className="flex items-center bg-[#FAFAFA] py-3.5 pl-3.5 pr-[18px] rounded-sm border border-[#F7F7F7] mb-1 relative">
        {/* Image container */}
        <div className="absolute top-0 flex rounded-full h-40 w-40 bg-[#E1E0E0] items-center justify-center">
          {/* @ts-ignore */}
          {agentUserDetails?.profilePic ? (
            <img
              // src={ProfileImg}
              src={agentUserDetails?.profilePic}
              className="rounded-full h-40 w-40 object-fill"
            />
          ) : (
            <span className="font-montserrat text-white font-semibold text-6xl uppercase">
              {/* @ts-ignore */}
              {agentUserDetails?.companyName?.charAt(0)}
            </span>
          )}
        </div>

        <div className="flex justify-between flex-1 gap-1 pl-96">
          <div className="flex flex-col gap-2 items-center">
            <span className="font-montserrat text-charcoal font-bold text-2xl border-b border-primary w-max">
              {agentUserDetails?.companyName}
            </span>
            <span className="font-montserrat text-charcoal font-medium text-xs max-[900px]:w-min">
              Recruitment Agency
            </span>
          </div>
          <div className="flex flex-col justify-between items-end relative">
            <span className="font-montserrat text-light-black font-semibold text-[11px] max-[900px]:w-min italic">
              {agentUserDetails?.refNo}
            </span>
          </div>
        </div>
      </div>

      {/* Main Body Wrapper */}
      <div className="flex flex-col mt-4 flex-1 overflow-hidden relative pl-36">
        <div className="h-px w-[80%] bg-[#F5F5F5] absolute right-0 top-[3.2rem]"></div>
        {/* Tab section */}
        <div className="flex items-center justify-evenly mt-[0.8rem]">
          {tabs?.map((item, index) => {
            return (
              <button
                key={index}
                onClick={() => handleTabClick(index)}
                style={{
                  borderBottom:
                    activeTab === index
                      ? "1px solid #2E2E2E"
                      : "2px solid transparent",
                }}
                className="px-2.5"
              >
                <span className="font-montserrat text-charcoal font-medium text-xs">
                  {item}
                </span>
              </button>
            );
          })}
        </div>
        {/* Render Body */}
        <div className="mt-8 flex-1 overflow-hidden">
          <RenderBody activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default ViewProfile;
